export const locale = {
    lang: "es",
    data: {
        DASHBOARD: {
            DASHBOARD: "Inicio",
        },
    },
};
